import { render, staticRenderFns } from "./ModalAfterAddToCart.vue?vue&type=template&id=6001bb41"
import script from "./ModalAfterAddToCart.vue?vue&type=script&lang=ts"
export * from "./ModalAfterAddToCart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports